// @flow

import React from 'react'
import type { Node as ReactNode } from 'react'
import { connect } from 'react-redux'

import { toggleInitialMount, changeActiveSort } from '../actions/parameters'
import { trackEvent, GA_LABEL } from '../utils/analytics'
import Searchbar from './Searchbar/Searchbar'
import Main from './Main/Main.js'
import Footer from './Footer/Footer.js'
import Header from './Header/Header.js'
import style from './App.css'

type Props = {
  view: string,
  title: string,
  placeholder: string,
  source: {
    text: string,
    href?: string,
    datasetHref?: string
  }
}

class App extends React.PureComponent<Props> {
  props: Props // <- Old API but eslint-plugin-react complains without it

  static defaultProps = {
    view: 'bar',
    title: '',
    placeholder: '',
    source: {
      text: ''
    }
  }
  componentDidMount = () => trackEvent({ action: 'DID_MOUNT', label: GA_LABEL })
  render = (): ReactNode => {
    const { title, placeholder, source } = this.props

    return (
      <div className={style.root}>
        <Header title={title} />
        <Searchbar placeholder={placeholder} />
        <Main />
        <Footer src={source} />
      </div>
    )
  }
}

const mapStateToProps = ({ parameters }) => {
  const { title, placeholder, source, view } = parameters
  return {
    title,
    placeholder,
    source,
    view
  }
}

const mapDispatchToProps = () => {
  return {
    toggleInitialMount,
    changeActiveSort
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)



// WEBPACK FOOTER //
// ./src/shared/components/App.js